import { AbstractCatalogImagesService } from '@abstract-services/catalog-images/1.0/catalog-images.abstract-service';
import * as ngCommonHttp from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CatalogImagesAPI } from '@constants/api';
import { Observable, catchError, from, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CatalogImagesService implements AbstractCatalogImagesService {
  putUrl: string;

  constructor(private http: ngCommonHttp.HttpClient) {
    this.putUrl = CatalogImagesAPI.PUT;
  }

  uploadImage(presignedUrl: string, imageFile: File): Observable<any> {
    return this.http.put(presignedUrl, imageFile, {
      headers: { 'Content-Type': imageFile.type },
    });
  }

  /**
   * Get image as a file from a given URL
   * @param url
   * @param fileName
   * @returns
   */
  fetchImageAsFile(url: string, fileName: string): Observable<File> {
    return from(fetch(url).then((response) => response.blob())).pipe(
      map((blob) => new File([blob], fileName, { type: blob.type })),
      catchError((error) => {
        throw error;
      }),
    );
  }
}
